export default {
      id: "icon-arc-en-ciel-usage",
      viewBox: "0 0 138 70.9",
      url: __webpack_public_path__ + "icons.svg#icon-arc-en-ciel",
      toString: function () {
        return this.url;
      }
    }